import {
  IQuoteByFlightData,
  IQuoteBySurfaceTravelPrivateData,
  IQuoteBySurfaceTravelPublicData,
  IQuoteFixed
} from "../@interfaces/quote.interface";

export enum CALCULATOR_MODE {
  oneway = "One way",
  return = "Return",
  multicity = "Multi-city",
}

export type PrivateTransportMethod = "CAR" | "MOTORBIKE" | "SCOOTER";
export type PrivateTransportCategory = "SMALL" | "MEDIUM" | "LARGE";
export type PublicTransportMethod = "BUS" | "TRAIN" | "FERRY";
export type PublicTransportCategory = "NATIONAL" | "INTERNATIONAL" | "SUBWAY" | "TRAM";
export type TransportPowerTrain = "PETROL" | "DIESEL" | "ELECTRIC" | "PHEV" | "HEV" | "EV";
export type QuoteTravelData = IQuoteBySurfaceTravelPublicData | IQuoteBySurfaceTravelPrivateData | IQuoteByFlightData | IQuoteFixed;
export type TravelRequestType = "PUBLIC" | "PRIVATE" | "FLIGHT" | "FIXED";

export type JourneyDataType = QuoteTravelData & {
  estimate: {
    co2eQuantity: number;
    co2eQuantityUnit: string;
    distanceCovered?: number;
    distanceUnit?: string;
    estimateId: string;
  };
  distance: {
    value: number;
    unit: string;
  };
  transportMethod: string
};

export function isSurfaceTravel(travel: QuoteTravelData): travel is (IQuoteBySurfaceTravelPublicData | IQuoteBySurfaceTravelPrivateData)  {
  return (travel as (IQuoteBySurfaceTravelPrivateData|IQuoteBySurfaceTravelPublicData))?.activityMetadata?.travels !== undefined; 
}

export function isFixedEstimate(travel: QuoteTravelData): travel is (IQuoteFixed)  {
  return (travel as IQuoteFixed)?.co2Quantity !== undefined; 
}